import React, { Component } from "react";
import { connect } from "react-redux";

import { Translate } from "react-redux-i18n";

import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

import evio_o from "../../styles/images/evio_o.svg";
import mapIcon from "../../styles/images/mapIcon.svg";
import avatar from "../../styles/images/avatar.svg";
import graph from "../../styles/images/graph.svg";
import car from "../../styles/images/car.svg";
import station from "../../styles/images/station.svg";
import battery from "../../styles/images/battery.svg";
/* import calendar from "../../styles/images/calendar.svg";
 */ import compare from "../../styles/images/compare.svg";
/* import navigation from "../../styles/images/navigation.svg";
 */
import question from "../../styles/images/question.svg";
import arrow from "../../styles/images/rightArrow.svg";
import separator from "../../styles/images/separator.svg";
import "../../styles/components/sidebar/Sidebar.scss";

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.state = {
      expanded: false,
    };

    this.toggleExpand = this.toggleExpand.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  toggleExpand() {
    this.safeSetState((prevState) => ({
      expanded: !prevState.expanded,
    }));
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <div
        id="sidebar"
        className={"evio-sidebar " + (this.state.expanded ? "expand" : "")}
      >
        <Nav className="menu">
          <Nav.Item className="logo">
            <Nav.Link as={Navbar.Brand} href="/insights">
              <div className="menu-entry">
                <img
                  alt="EVIO"
                  src={this.props.brand?.icons?.principalIcon || evio_o}
                  className="align-middle pic"

                />
              </div>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className="profile">
            <Nav.Link as={Navbar.Brand} href="/account">
              <div className="menu-entry">
                <OverlayTrigger
                  placement="right"
                  trigger={["hover", "focus"]}
                  overlay={
                    <Tooltip
                      className={
                        "evio-tooltip " + (this.state.expanded && "hidden")
                      }
                    >
                      <Translate value="label_manageAccount" />
                    </Tooltip>
                  }
                >
                  <img
                    src={
                      this.props.accountData.avatar &&
                        this.props.accountData.avatar !== ""
                        ? this.props.accountData.avatar
                        : avatar
                    }
                    className="align-middle pic"
                    alt="avatar"
                  />
                </OverlayTrigger>
                <label>
                  <Translate value="label_manageAccount" />
                </label>
              </div>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className="comparator">
            <Nav.Link as={Navbar.Brand} href="/map">
              <div className="menu-entry">
                <OverlayTrigger
                  placement="right"
                  trigger={["hover", "focus"]}
                  overlay={
                    <Tooltip
                      className={
                        "evio-tooltip " + (this.state.expanded && "hidden")
                      }
                    >
                      <Translate value="label_map" />
                    </Tooltip>
                  }
                >
                  <img
                    alt="mapIcon"
                    src={mapIcon}
                    className="align-middle pic"
                  />
                </OverlayTrigger>
                <label>
                  <Translate value="label_map" />
                </label>
              </div>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className="insights">
            <Nav.Link as={Navbar.Brand} href="/insights">
              <div className="menu-entry">
                <OverlayTrigger
                  placement="right"
                  trigger={["hover", "focus"]}
                  overlay={
                    <Tooltip
                      className={
                        "evio-tooltip " + (this.state.expanded && "hidden")
                      }
                    >
                      <Translate value="label_viewInsights" />
                    </Tooltip>
                  }
                >
                  <img
                    src={graph}
                    className="align-middle pic"
                    alt="insights"
                  />
                </OverlayTrigger>
                <label>
                  <Translate value="label_viewInsights" />
                </label>
              </div>
            </Nav.Link>
          </Nav.Item>

          <Nav.Item className="separator">
            <div className="menu-entry">
              <img src={separator} className="align-middle pic" alt="" />
            </div>
          </Nav.Item>
          <Nav.Item className="fleets">
            <Nav.Link as={Navbar.Brand} href="/fleets">
              <div className="menu-entry">
                <OverlayTrigger
                  placement="right"
                  trigger={["hover", "focus"]}
                  overlay={
                    <Tooltip
                      className={
                        "evio-tooltip " + (this.state.expanded && "hidden")
                      }
                    >
                      <Translate value="label_myEVs" />
                    </Tooltip>
                  }
                >
                  <img src={car} className="align-middle pic" alt="fleets" />
                </OverlayTrigger>
                <label>
                  <Translate value="label_myEVs" />
                </label>
              </div>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className="chargers">
            <Nav.Link as={Navbar.Brand} href="/chargers">
              <div className="menu-entry">
                <OverlayTrigger
                  placement="right"
                  trigger={["hover", "focus"]}
                  overlay={
                    <Tooltip
                      className={
                        "evio-tooltip " + (this.state.expanded && "hidden")
                      }
                    >
                      <Translate value="label_myChargers" />
                    </Tooltip>
                  }
                >
                  <img
                    src={station}
                    className="align-middle pic"
                    alt="chargers"
                  />
                </OverlayTrigger>
                <label>
                  <Translate value="label_myChargers" />
                </label>
              </div>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className="separator">
            <div className="menu-entry">
              <img src={separator} className="align-middle pic" alt="" />
            </div>
          </Nav.Item>
          <Nav.Item className="sessions">
            <Nav.Link as={Navbar.Brand} href="/sessions">
              <div className="menu-entry">
                <OverlayTrigger
                  placement="right"
                  trigger={["hover", "focus"]}
                  overlay={
                    <Tooltip
                      className={
                        "evio-tooltip " + (this.state.expanded && "hidden")
                      }
                    >
                      <Translate value="label_sessions" />
                    </Tooltip>
                  }
                >
                  <img
                    src={battery}
                    className="align-middle pic"
                    alt="sessions"
                  />
                </OverlayTrigger>
                <label>
                  <Translate value="label_sessions" />
                </label>
              </div>
            </Nav.Link>
          </Nav.Item>
          {/*           <Nav.Item className="bookings">
            <Nav.Link as={Navbar.Brand} href="/bookings">
              <div className="menu-entry">
                <OverlayTrigger
                  placement="right"
                  trigger={["hover", "focus"]}
                  popperConfig={{
                    modifiers: {
                      preventOverflow: {
                        enabled: false,
                      },
                    },
                  }}
                  overlay={
                    <Tooltip
                      className={
                        "evio-tooltip " + (this.state.expanded && "hidden")
                      }
                    >
                      <Translate value="label_bookings" />
                    </Tooltip>
                  }
                >
                  <img
                    src={calendar}
                    className="align-middle pic"
                    alt="bookings"
                  />
                </OverlayTrigger>
                <label>
                  <Translate value="label_bookings" />
                </label>
              </div>
            </Nav.Link>
          </Nav.Item> */}
          {this.props.brand?.brandName === "EVIO" && (
            <>
              <Nav.Item className="separator">
                <div className="menu-entry">
                  <img src={separator} className="align-middle pic" alt="" />
                </div>
              </Nav.Item>
              <Nav.Item className="comparator">
                <Nav.Link as={Navbar.Brand} href="/comparator">
                  <div className="menu-entry">
                    <OverlayTrigger
                      placement="right"
                      trigger={["hover", "focus"]}
                      overlay={
                        <Tooltip
                          className={
                            "evio-tooltip " + (this.state.expanded && "hidden")
                          }
                        >
                          <Translate value="label_comparator" />
                        </Tooltip>
                      }
                    >
                      <img
                        src={compare}
                        className="align-middle pic"
                        alt="comparator"
                      />
                    </OverlayTrigger>
                    <label>
                      <Translate value="label_comparator" />
                    </label>
                  </div>
                </Nav.Link>
              </Nav.Item>
            </>
          )}
          {/* <Nav.Item className="router">
            <Nav.Link as={Navbar.Brand} href="/router">
              <div className="menu-entry">
                <OverlayTrigger
                  placement="right"
                  trigger={["hover", "focus"]}
                  popperConfig={{
                    modifiers: {
                      preventOverflow: {
                        enabled: false,
                      },
                    },
                  }}
                  overlay={
                    <Tooltip
                      className={
                        "evio-tooltip " + (this.state.expanded && "hidden")
                      }
                    >
                      <Translate value="label_router" />
                    </Tooltip>
                  }
                >
                  <img
                    src={navigation}
                    className="align-middle pic"
                    alt="router"
                  />
                </OverlayTrigger>
                <label>
                  <Translate value="label_router" />
                </label>
              </div>
            </Nav.Link>
          </Nav.Item> */}
          <Nav.Item className="separator">
            <div className="menu-entry">
              <img src={separator} className="align-middle pic" alt="" />
            </div>
          </Nav.Item>
          <Nav.Item className="support">
            <Nav.Link as={Navbar.Brand} href="/support">
              <div className="menu-entry">
                <OverlayTrigger
                  placement="right"
                  trigger={["hover", "focus"]}
                  overlay={
                    <Tooltip
                      className={
                        "evio-tooltip " + (this.state.expanded && "hidden")
                      }
                    >
                      <Translate value="label_support" />
                    </Tooltip>
                  }
                >
                  <img
                    src={question}
                    className="align-middle pic"
                    alt="support"
                  />
                </OverlayTrigger>
                <label>
                  <Translate value="label_support" />
                </label>
              </div>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className="expand">
            <div className="menu-entry">
              <button
                type="button"
                className="clear"
                onClick={this.toggleExpand}
              >
                <img src={arrow} className="align-middle pic" alt="expand" />
              </button>
            </div>
          </Nav.Item>
        </Nav>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  accountData: state.account.accountData,
  brand: state.app.brand,
});

export default connect(mapStateToProps, null)(Sidebar);
